export function Hoenn(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      {...props}
    >
      {}
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.505 13.341a2.35 2.35 0 0 0 1.498-1.35a2.49 2.49 0 0 0 2.499 1.5A2.49 2.49 0 0 0 7 11.99a2.49 2.49 0 0 0 2.498 1.5a2.49 2.49 0 0 0 2.499-1.5a2.35 2.35 0 0 0 1.499 1.35M.505 9.344a2.38 2.38 0 0 0 1.498-1.35c.418.976 1.5 1.5 2.499 1.5c1.998 0 3.497-1.5 3.497-2.998C8 4.497 7 2.499 4.502 3.498C4.668 2.498 5.7.5 8.499.5s4.497 1.999 4.996 2.998"
      />
    </svg>
  );
}
